export const GET_SYSTEM_BRANDS = 'pam/GET_SYSTEM_BRANDS'
export const GET_SYSTEM_BRANDS_SUCCESS = 'pam/GET_SYSTEM_BRANDS_SUCCESS'
export const GET_SYSTEM_BRANDS_FAIL = 'pam/GET_SYSTEM_BRANDS_FAIL'

export const indexGetSystemBrands = payload => ({
  type: GET_SYSTEM_BRANDS,
  payload
})

export const indexGetSystemBrandsSuccess = payload => ({
  type: GET_SYSTEM_BRANDS_SUCCESS,
  payload
})

export const indexGetSystemBrandsFail = payload => ({
  type: GET_SYSTEM_BRANDS_FAIL,
  payload
})
